<template>
<div class="container">
	<div class="page page-submission-details">
		<div class="page-header">
			<h1 class="page-title">{{ pageTitle }}</h1>
		</div>
		<div class="page-content">
			<div
				class="is-loading large dark"
				v-if="isFetching">
			</div>
			<div
				class="submission-invoice"
				v-if="!isFetching">
				<invoice
					class="has-shadow"
					:store="user.store"
					:order="submission"
					v-if="submission">
				</invoice>
				<!-- Tracking History -->
				<div
					class="box mb-0 mt-3 px-4"
					v-if="hasTrackingHistories">
					<div class="text-bold mb-3">Status Pengiriman:</div>
					<div class="shipment-histories">
						<shipment-list
							v-for="(history, index) in trackingHistories"
							:key="index"
							:history="history"
							:courier="courier">
						</shipment-list>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Invoice from '../components/Invoice.vue';
import ShipmentList from '../components/ShipmentList.vue';
import submissionsApi from '../api/submissions';

export default {
	name: 'submissionDetails',
	components: {
		Invoice,
		ShipmentList,
	},
	data() {
		return {
			pageTitle: 'Order Details',
			submission: false,
			isFetching: false,
		};
	},
	methods: {
		fetchDetails() {
			this.isFetching = true;
			const callback = (response) => {
				const submission = response.data;
				this.submission = submission;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				this.isFetching = false;
			};
			submissionsApi.getDetails(this.id, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		id() {
			return this.$route.params.id;
		},
		hasTrackingHistories() {
			return this.submission && this.submission.shipping && this.submission.shipping.trackings && this.submission.shipping.trackings.history;
		},
		trackingHistories() {
			let histories = this.submission
				&& this.submission.shipping
				&& this.submission.shipping.trackings
				&& this.submission.shipping.trackings.history
				? this.submission.shipping.trackings.history : [];
			histories = histories.reverse();
			return histories;
		},
		courier() {
			return this.submission.shipping ? this.submission.shipping.courier : '';
		},
	},
	created() {
		this.fetchDetails();
	},
	watch: {
		id() {
			this.fetchDetails();
		},
	},
};
</script>
